/* eslint-disable import/no-cycle */
import { put, takeEvery } from "redux-saga/effects";
import { companyKpisActions } from "../slice/companyKpis";
import { fetchCompanyKpis } from "../../apis/companyKpis";

export function* getCompanyKpisList({ payload }) {
  try {
    const companyKpis = yield fetchCompanyKpis(payload);
    if (companyKpis?.data?.success) {
      yield put(
        companyKpisActions.getCompanyKpisSuccess({
          data: companyKpis?.data?.data,
          count: companyKpis?.data?.count,
        })
      );
    } else {
      yield put(
        companyKpisActions.getCompanyKpisFailed({ errorMessage: companyKpis.data.message })
      );
    }
  } catch (error) {
    yield put(
      companyKpisActions.getCompanyKpisFailed({
        errorMessage: error.data.data.message || "Something went wrong",
      })
    );
  }
}

export function* watchCompanyKpisAsync() {
  yield takeEvery(companyKpisActions.getCompanyKpisRequest, getCompanyKpisList);
}
